import React, {FC} from "react";
import vielenDank1 from "./VielenDank1.png";
import sieHabenMail from "./sieHabenMail.png";
import {Container, Typography} from "@material-ui/core";

interface EndStepProps {
    isDesktop: boolean
}

export const EndStep: FC<EndStepProps> = ({isDesktop}) => {
    return (
        <Container style={{marginTop: 40}}>
            <div style={{position: "relative", display: "flex"}}>
                <img alt="vielen dank" src={vielenDank1} width={"100%"}/>
                <Typography
                    variant="h4"
                    color="secondary"
                    style={{position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)"}}
                >
                    Vielen Dank
                </Typography>
            </div>
            <div style={{display: "flex", alignItems: "center", flexDirection: "column"}}>
                <Typography variant="h5" color="secondary"
                            style={{textAlign: "center", marginTop: 64, marginBottom: 24}}>
                    Bitte bestätigen Sie Ihre Buchung
                </Typography>
                <img style={{marginLeft: "auto", marginRight: "auto"}} alt="vielen dank" src={sieHabenMail}
                     width={200}/>
                <Typography variant={isDesktop ? "h3" : "h5"} color="secondary" style={{textAlign: "center", marginBottom: 120}}>
                    Sie haben soeben eine E-Mail von uns erhalten.<br/>Bitte prüfen Sie ihren Posteingang.
                </Typography>
            </div>
        </Container>
    )
}
